import React from "react"
import numeral from "numeral"

export const HoursSegment = props => {
    const hours = []
    for (const time_type of ["ST", "OT", "DT"]) {
        const css = { width: "28px" }
        let content = "-"
        if (props.value[time_type]) {
            content = numeral(props.value[time_type]).format("0.[00]")
        } else {
            css.opacity = "0.5"
        }
        hours.push(
            <div style={css} key={time_type}>
                {content}
            </div>
        )
    }
    return <div className="hours-row">{hours}</div>
}

export const TotalColumnHoursSegment = props => {
    const hours = []
    const total = props.value["ST"] + props.value["OT"] + props.value["DT"]

    if (total) {
        hours.push(<div key="Total">{numeral(total).format("0.[00]")}</div>)
    } else {
        hours.push(
            <div style={{ opacity: 0.5 }} key="Total">
                --
            </div>
        )
    }

    for (const time_type of ["ST", "OT", "DT"]) {
        const timeColumnCss = {}
        let content = "-"
        if (props.value[time_type]) {
            content = numeral(props.value[time_type]).format("0.[00]")
        } else {
            timeColumnCss.opacity = "0.5"
        }
        hours.push(
            <div style={timeColumnCss} key={time_type}>
                {content}
            </div>
        )
    }
    return <div className="hours-row">{hours}</div>
}
